import React, { FC, memo } from 'react';
import { InputNumber, Radio, Space } from 'udesk-ui';
import styled from 'styled-components';
import SampleUpperLimit, {
    TemplateProps as SampleUpperLimitProps,
} from './components/SampleUpperLimit';
import UdeskLocales from 'UdeskLocales';

const Wrapper = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    gap: 10px;
`;

const labelStyle: React.CSSProperties = {
    width: 70,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

export const FilterMethodMap = {
    ALL: 0,
    PART: 1,
};

interface TemplateProps {
    value?: {
        enable?: number;
        ratio?: number;
    } & SampleUpperLimitProps['value'];
    onChange?: (value: TemplateProps['value']) => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange } = props;

    return (
        <Wrapper>
            <Space>
                <div style={labelStyle}>
                    {/* 过滤方式: */}
                    {
                        UdeskLocales['current'].pages.speechRecognition.components.aSRFilterMethod
                            .index.filteringMethod
                    }
                </div>

                <Radio.Group
                    options={[
                        {
                            value: FilterMethodMap.ALL,
                            label: /* 符合条件的全部通话执行ASR */ UdeskLocales['current'].pages
                                .speechRecognition.components.aSRFilterMethod.index
                                .allEligibleCallsPerformASR,
                        },
                        {
                            value: FilterMethodMap.PART,
                            label: /* 符合条件的部分通话执行ASR */ UdeskLocales['current'].pages
                                .speechRecognition.components.aSRFilterMethod.index
                                .performASRForEligiblePartialCalls,
                        },
                    ]}
                    value={value?.enable}
                    onChange={(e) => onChange?.({ ...value, enable: e.target.value })}
                />
            </Space>

            {value?.enable === FilterMethodMap.PART ? (
                <>
                    <div>
                        <Space>
                            <div style={labelStyle}>
                                {/* 抽样比例: */}
                                {
                                    UdeskLocales['current'].pages.speechRecognition.components
                                        .aSRFilterMethod.index.samplingRatio
                                }
                            </div>
                            <div>
                                <Space>
                                    <InputNumber
                                        value={value.ratio}
                                        onChange={(e) => onChange?.({ ...value, ratio: e })}
                                        min={1}
                                        max={100}
                                        precision={0}
                                    />
                                    <span>%</span>
                                </Space>
                            </div>
                        </Space>
                    </div>

                    <div>
                        <Space>
                            <div style={labelStyle}>
                                {/* 抽样上限: */}
                                {
                                    UdeskLocales['current'].pages.speechRecognition.components
                                        .aSRFilterMethod.index.upperSamplingLimit
                                }
                            </div>
                            <SampleUpperLimit
                                value={{
                                    cycle: value.cycle,
                                    dimensions: value.dimensions,
                                    limit: value.limit,
                                }}
                                onChange={(e) => onChange?.({ ...value, ...e })}
                            />
                        </Space>
                    </div>
                </>
            ) : null}
        </Wrapper>
    );
});

export default Template;
